module.exports = __webpack_public_path__ + "assets/38af50b243957b9d787927ef2548d02c.mp3";